import { connect } from '@iris-platform/incontext';
import { withApollo } from 'react-apollo';
import {
  applySpec, compose, curry, prop,
} from 'ramda';
import { KeySpaceManager } from '../components';
import {
  createNewKey, discardNewKey, saveNewKey, updateNewKey,
} from '../actions';

const mapStateToProps = applySpec({
  modelsByDomainOrToken: prop('keySpaceManagers'),
  useBasicAuth: prop('useBasicAuth'),
});

const mapDispatchToProps = (dispatch, { client }) => ({
  onChangeNewKey: curry(compose(dispatch, updateNewKey)),
  onCreateNewKey: compose(dispatch, createNewKey),
  onSaveNewKey: saveNewKey(dispatch, client),
  onDiscardNewKey: compose(dispatch, discardNewKey),
});

const KeySpaceManagerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(KeySpaceManager);

export default withApollo(KeySpaceManagerContainer);
